<template>
  <div v-if="userId">
    <h1 class="center-align course-name">Lineage Independence Trust Program</h1>
    <v-container>
      <v-row>
        <v-col>
          <v-sheet align="center" justify="center">
            <system-messages-widget :user-id="userId"></system-messages-widget>
            <assessments-widget :user-id="userId"></assessments-widget>
          </v-sheet>
        </v-col>
        <v-col style="display: flex; align-items: center;">
          <v-sheet align="center" justify="center">
            <assigned-learning-items-widget
              :user-id="userId"
            ></assigned-learning-items-widget>
            <trophy-case :user-id="userId"></trophy-case>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import AssessmentsWidget from "@/containers/dashboards/AssessmentsWidget"
import AssignedLearningItemsWidget from "@/containers/dashboards/AssignedLearningItemsWidget"
import SystemMessagesWidget from "@/containers/dashboards/SystemMessagesWidget"
import TrophyCase from "@/containers/dashboards/TrophyCase"
export default {
  mixins: [titleMixin],
  components: {
    AssessmentsWidget,
    AssignedLearningItemsWidget,
    SystemMessagesWidget,
    TrophyCase
  },
  data: function() {
    return {
      userId: parseInt(this.$route.params.id)
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.userId = parseInt(to.params.id)
      // this.$store.dispatch("courses/loadCourses", {
      //   showTemplates: false,
      //   includeHidden: false
      // })
      this.$store.dispatch("assessments/assessmentsByUserId", {
        userId: this.userId
      })
      this.$store.dispatch("systemMessages/loadMessages", this.userId)
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/title";
.course-name {
  color: $very-dark-grey;
  text-transform: uppercase;
}

.center-align {
  display: flex;
  justify-content: center;
}
div.v-sheet {
  width: 100%;
}
div.col {
  min-width: 347px;
}
</style>
